import React from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangleIcon, CheckCircleIcon, CrownIcon } from 'lucide-react';
import { currentUser, licensePlans, getDaysRemaining, isLicenseExpired } from '../utils/mockData';
const LicenseStatus = () => {
  if (!currentUser.license) {
    return <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4" data-id="element-185">
        <div className="flex items-start" data-id="element-186">
          <AlertTriangleIcon className="h-5 w-5 text-yellow-600 mr-3 mt-0.5" data-id="element-187" />
          <div className="flex-1" data-id="element-188">
            <h3 className="text-sm font-medium text-yellow-900" data-id="element-189">
              No Active License
            </h3>
            <p className="text-sm text-yellow-700 mt-1" data-id="element-190">
              You need an active license to create property listings.
            </p>
            <Link to="/license-plans" className="inline-block mt-2 text-sm font-medium text-yellow-900 hover:text-yellow-800 underline" data-id="element-191">
              View License Plans →
            </Link>
          </div>
        </div>
      </div>;
  }
  const license = currentUser.license;
  const plan = licensePlans.find(p => p.id === license.licenseId);
  const daysRemaining = getDaysRemaining(license.expiryDate);
  const isExpired = isLicenseExpired(license.expiryDate);
  const percentageUsed = license.usedListings / license.maxListings * 100;
  const listingsRemaining = license.maxListings - license.usedListings;
  if (isExpired) {
    return <div className="bg-red-50 border border-red-200 rounded-lg p-4" data-id="element-192">
        <div className="flex items-start" data-id="element-193">
          <AlertTriangleIcon className="h-5 w-5 text-red-600 mr-3 mt-0.5" data-id="element-194" />
          <div className="flex-1" data-id="element-195">
            <h3 className="text-sm font-medium text-red-900" data-id="element-196">
              License Expired
            </h3>
            <p className="text-sm text-red-700 mt-1" data-id="element-197">
              Your license has expired. Renew now to continue posting listings.
            </p>
            <Link to="/license-plans" className="inline-block mt-2 text-sm font-medium text-red-900 hover:text-red-800 underline" data-id="element-198">
              Renew License →
            </Link>
          </div>
        </div>
      </div>;
  }
  if (listingsRemaining === 0) {
    return <div className="bg-orange-50 border border-orange-200 rounded-lg p-4" data-id="element-199">
        <div className="flex items-start" data-id="element-200">
          <AlertTriangleIcon className="h-5 w-5 text-orange-600 mr-3 mt-0.5" data-id="element-201" />
          <div className="flex-1" data-id="element-202">
            <h3 className="text-sm font-medium text-orange-900" data-id="element-203">
              Listing Limit Reached
            </h3>
            <p className="text-sm text-orange-700 mt-1" data-id="element-204">
              You've used all {license.maxListings} listings in your{' '}
              {plan?.planName} plan.
            </p>
            <Link to="/license-plans" className="inline-block mt-2 text-sm font-medium text-orange-900 hover:text-orange-800 underline" data-id="element-205">
              Upgrade Plan →
            </Link>
          </div>
        </div>
      </div>;
  }
  if (daysRemaining <= 7) {
    return <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4" data-id="element-206">
        <div className="flex items-start" data-id="element-207">
          <AlertTriangleIcon className="h-5 w-5 text-yellow-600 mr-3 mt-0.5" data-id="element-208" />
          <div className="flex-1" data-id="element-209">
            <h3 className="text-sm font-medium text-yellow-900" data-id="element-210">
              License Expiring Soon
            </h3>
            <p className="text-sm text-yellow-700 mt-1" data-id="element-211">
              Your license expires in {daysRemaining} day
              {daysRemaining !== 1 ? 's' : ''}. Renew now to avoid interruption.
            </p>
            <Link to="/license-plans" className="inline-block mt-2 text-sm font-medium text-yellow-900 hover:text-yellow-800 underline" data-id="element-212">
              Renew License →
            </Link>
          </div>
        </div>
      </div>;
  }
  return <div className="bg-white border border-gray-200 rounded-lg p-4" data-id="element-213">
      <div className="flex items-start justify-between mb-3" data-id="element-214">
        <div className="flex items-center" data-id="element-215">
          <CrownIcon className="h-5 w-5 text-blue-600 mr-2" data-id="element-216" />
          <div data-id="element-217">
            <h3 className="text-sm font-medium text-gray-900 capitalize" data-id="element-218">
              {plan?.planName} Plan
            </h3>
            <p className="text-xs text-gray-500" data-id="element-219">
              Expires in {daysRemaining} days
            </p>
          </div>
        </div>
        <Link to="/license-plans" className="text-sm font-medium text-blue-600 hover:text-blue-800" data-id="element-220">
          Upgrade
        </Link>
      </div>
      <div className="space-y-2" data-id="element-221">
        <div className="flex justify-between text-sm" data-id="element-222">
          <span className="text-gray-600" data-id="element-223">Listings Used</span>
          <span className="font-medium text-gray-900" data-id="element-224">
            {license.usedListings} / {license.maxListings}
          </span>
        </div>
        <div className="w-full bg-gray-200 rounded-full h-2" data-id="element-225">
          <div className={`h-2 rounded-full transition-all duration-300 ${percentageUsed >= 90 ? 'bg-red-600' : percentageUsed >= 70 ? 'bg-yellow-600' : 'bg-blue-600'}`} style={{
          width: `${percentageUsed}%`
        }} data-id="element-226" />
        </div>
        <p className="text-xs text-gray-500" data-id="element-227">
          {listingsRemaining} listing{listingsRemaining !== 1 ? 's' : ''}{' '}
          remaining
        </p>
      </div>
    </div>;
};
export default LicenseStatus;